import { Component, computed, inject } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { NgbTooltip } from '@ng-bootstrap/ng-bootstrap';
import { BRANDING } from '../../branding';
import { ConfigurationService } from '../../services/configuration.service';
import { BrandMark } from '../../shared/brand-mark/brand-mark';
import { ThemeService } from '../../services/theme.service';
import { UserSessionService } from '../../services/user-session.service';
import { MENU_GROUPS } from '../menu.config';

@Component({
  selector: 'app-default-sidebar',
  imports: [RouterLink, RouterLinkActive, NgbTooltip, BrandMark],
  templateUrl: './default-sidebar.component.html',
  styleUrl: './default-sidebar.component.scss',
})
export class DefaultSidebarComponent {
  private readonly session = inject(UserSessionService);
  protected readonly theme = inject(ThemeService);
  protected readonly config = inject(ConfigurationService);
  protected readonly brand = BRANDING;

  /** Menu filtered by the user's functionalities; empty groups are dropped. */
  protected readonly groups = computed(() => {
    this.session.currentUser(); // re-evaluate when the session changes
    return MENU_GROUPS.map((g) => ({ ...g, items: g.items.filter((i) => this.session.hasAnyAccess(i.fncodes)) })).filter((g) => g.items.length > 0);
  });

  protected readonly collapsed = computed(() => this.theme.sidebarCollapsed() && !this.theme.mobileSidebarOpen());
}
